import React from 'react';
import { rateAge } from '../utils/rateAge';

// A small color-coded pill showing how old a rate observation is (e.g. "8mo",
// "1.5y", "5y"), green→red by tier. The native title gives a reliability note
// on hover. Renders nothing when the date is missing/invalid.
export function RateAgePill({ date, now, style }) {
  const age = rateAge(date, now);
  if (!age) return null;
  return (
    <span
      title={age.tooltip}
      style={{
        display: 'inline-block',
        fontSize: '0.66rem',
        lineHeight: 1.4,
        padding: '0 0.32rem',
        borderRadius: 999,
        border: `1px solid ${age.color}`,
        color: age.color,
        background: 'transparent',
        whiteSpace: 'nowrap',
        cursor: 'help',
        ...style,
      }}
    >
      {age.label}
    </span>
  );
}

export default RateAgePill;
